import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { kv } from '../../lib/format';
import { cardPad } from '../../lib/ui';

export default function Award() {
  const { state, go, set, L } = useApp();
  const choice = state.selectedBid;

  const scoreByAlias: Record<'A' | 'B' | 'C', number> = { A: 94, B: 87, C: 79 };
  const premByAlias: Record<'A' | 'B' | 'C', string> = { A: '$4,620,000', B: '$4,785,000', C: '$4,955,000' };
  const rankByAlias: Record<'A' | 'B' | 'C', number> = { A: 1, B: 2, C: 3 };

  const showOverride = choice !== 'A' && !state.awardConfirmed;
  const overrideCount = state.overrideText.length;
  const overrideCountColor = state.overrideText.length >= 50 ? 'var(--color-success)' : 'var(--color-fg-3)';
  const overrideOk = choice === 'A' || state.overrideText.length >= 50;

  const awardChoices = (['A', 'B', 'C'] as const).map((a) => {
    const sel = a === choice;
    return {
      key: a,
      alias: 'Supplier ' + a,
      premium: premByAlias[a],
      score: scoreByAlias[a],
      rank: rankByAlias[a],
      recommended: a === 'A',
      border: sel ? 'var(--color-blue)' : 'var(--color-border)',
      bg: sel ? 'var(--color-blue-100)' : 'var(--color-white)',
      radioBorder: sel ? 'var(--color-blue)' : 'var(--color-border-strong)',
      radioFill: sel ? 'var(--color-blue)' : 'transparent',
      onSelect: () => set({ selectedBid: a }),
    };
  });

  const confirmLabel = choice === 'A' ? L('Confirm Award & Generate PO', 'ยืนยันการมอบสัญญาและออกใบสั่งซื้อ') : L('Confirm Override & Generate PO', 'ยืนยันการแทนที่และออกใบสั่งซื้อ');
  const confirmOpacity = overrideOk ? 1 : 0.4;
  const confirmAward = () => {
    if (overrideOk) set({ awardConfirmed: true });
  };

  const rfqSummary = [
    kv(L('RFQ ID', 'รหัส RFQ'), 'RFQ-2026-001', 'var(--font-mono)'),
    kv(L('Title', 'ชื่อเรื่อง'), 'Fleet Vehicle Insurance — Class 1 Batch', 'var(--font-sans)'),
    kv(L('Method', 'วิธีการ'), 'e-Bidding', 'var(--font-sans)'),
    kv(L('Bids Received', 'ข้อเสนอที่ได้รับ'), '3 of 4', 'var(--font-sans)'),
    kv(L('Selected Bid', 'ข้อเสนอที่เลือก'), premByAlias[choice], 'var(--font-mono)'),
    kv(L('DOA Level Required', 'ระดับ DOA ที่ต้องใช้'), 'Executive Committee', 'var(--font-sans)'),
  ];
  const revealGrid = [
    kv(L('Contact Person', 'ผู้ติดต่อ'), 'Somchai Prasert', 'var(--font-sans)'),
    kv(L('Email', 'อีเมล'), 'bids@apex-insurance.co', 'var(--font-mono)'),
    kv(L('Phone', 'โทรศัพท์'), '+66 2 555 0101', 'var(--font-mono)'),
    kv(L('Tax ID (Registry)', 'เลขประจำตัวผู้เสียภาษี (ทะเบียน)'), '0105539001234', 'var(--font-mono)'),
    kv(L('Address', 'ที่อยู่'), '88 Rama IV Rd, Bangkok', 'var(--font-sans)'),
    kv(L('Bid Total', 'ยอดข้อเสนอราคารวม'), '$4,620,000', 'var(--font-mono)'),
  ];
  const auditRows = [
    { ts: '2026-06-20 14:02:11', user: 'Maria B.', role: L('Procurement', 'จัดซื้อ'), action: 'AWARD_DECISION · Supplier A (Apex Insurance Co.)' },
    { ts: '2026-06-20 14:01:55', user: 'System', role: L('AI Engine', 'เครื่องมือ AI'), action: 'DEMASK · aliases resolved to vendor IDs' },
    { ts: '2026-06-18 09:14:03', user: 'System', role: L('AI Engine', 'เครื่องมือ AI'), action: 'BID_SCORE · Supplier A = 94' },
    { ts: '2026-06-18 09:12:40', user: 'Supplier A', role: L('Vendor', 'ผู้ขาย'), action: 'BID_SUBMIT · $4,620,000' },
  ];

  return (
    <>
      {state.awardConfirmed ? (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 18px', background: 'var(--color-success-bg)', border: '1px solid var(--color-success-border)', borderRadius: 'var(--radius-md)', marginBottom: 18, color: 'var(--color-success-ink)' }}>
            <Icon name="check" style={{ fontSize: 20 }} />
            <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--color-fg-1)' }}>{L('Award Confirmed — Supplier A selected', 'ยืนยันการมอบสัญญาแล้ว — เลือก Supplier A')}</div>
            <div style={{ flex: 1 }} />
            <button className="hv-ink" style={{ padding: '8px 14px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', fontSize: 13, fontWeight: 600, background: 'var(--color-white)', color: 'var(--color-fg-1)' }}>{L('Export Award Report', 'ส่งออกรายงานการมอบสัญญา')}</button>
            <button onClick={() => go('po')} className="hv-primary" style={{ padding: '8px 14px', background: 'var(--color-primary)', color: '#fff', borderRadius: 'var(--radius-sm)', fontSize: 13, fontWeight: 600 }}>{L('Proceed to PO →', 'ดำเนินการต่อไปยังใบสั่งซื้อ →')}</button>
          </div>
          <div style={{ background: 'var(--color-white)', border: '1.5px solid var(--color-success-border)', borderRadius: 'var(--radius-md)', padding: 22, marginBottom: 16 }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: 'var(--color-success-ink)', marginBottom: 8 }}>
              <Icon name="badge-check" style={{ fontSize: 14 }} />{L('Identity revealed · Supplier A is', 'เปิดเผยตัวตน · Supplier A คือ')}
            </div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 600, letterSpacing: '-.01em', lineHeight: 1.1, marginBottom: 16 }}>Apex Insurance Co.</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 14 }}>
              {revealGrid.map((g, i) => (
                <div key={i}>
                  <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)', marginBottom: 2 }}>{g.k}</div>
                  <div style={{ fontSize: 13, fontWeight: 600, fontFamily: g.font }}>{g.v}</div>
                </div>
              ))}
            </div>
          </div>
          <div style={cardPad(0, 'auto')}>
            <div style={{ padding: '14px 18px', fontWeight: 700, borderBottom: '1px solid var(--color-border)' }}>{L('Full Audit Log', 'บันทึกการตรวจสอบทั้งหมด')}</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
                  <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Timestamp', 'เวลา')}</th>
                  <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('User', 'ผู้ใช้')}</th>
                  <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Role', 'บทบาท')}</th>
                  <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Action', 'การดำเนินการ')}</th>
                </tr>
              </thead>
              <tbody>
                {auditRows.map((a, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid var(--color-border)' }}>
                    <td style={{ padding: '10px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{a.ts}</td>
                    <td style={{ padding: '10px 16px', fontWeight: 600 }}>{a.user}</td>
                    <td style={{ padding: '10px 16px' }}>
                      <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: 'var(--color-ink-50)', color: 'var(--color-fg-2)' }}>{a.role}</span>
                    </td>
                    <td style={{ padding: '10px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{a.action}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 16, alignItems: 'start' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={cardPad(20)}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '11px 14px', background: 'var(--color-blue-100)', borderRadius: 'var(--radius-sm)', marginBottom: 16, fontSize: 13, color: 'var(--color-blue-700)' }}>
                <Icon name="eye-off" />{L('Blind evaluation — supplier identities revealed only after award is confirmed.', 'การประเมินแบบปิดตา — จะเปิดเผยตัวตนของซัพพลายเออร์หลังจากยืนยันการมอบสัญญาเท่านั้น')}
              </div>
              <div style={{ fontWeight: 700, marginBottom: 12 }}>{L('Select Winning Bid', 'เลือกข้อเสนอที่ชนะ')}</div>
              {awardChoices.map((c) => (
                <button key={c.key} onClick={c.onSelect} style={{ width: '100%', textAlign: 'left', display: 'flex', alignItems: 'center', gap: 12, padding: 14, border: `2px solid ${c.border}`, borderRadius: 'var(--radius-sm)', marginBottom: 10, background: c.bg }}>
                  <span style={{ width: 20, height: 20, borderRadius: 999, border: `2px solid ${c.radioBorder}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ width: 10, height: 10, borderRadius: 999, background: c.radioFill }} />
                  </span>
                  <Icon name="eye-off" style={{ color: 'var(--color-fg-3)' }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700 }}>{c.alias}</div>
                    <div style={{ fontSize: 12, color: 'var(--color-fg-3)' }}>{L('Premium', 'เบี้ยประกัน')} {c.premium} · {L('AI score', 'คะแนน AI')} {c.score} · {L('Rank #', 'อันดับ #')}{c.rank}</div>
                  </div>
                  {c.recommended && (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 'var(--radius-sm)', background: 'var(--color-success-bg)', border: '1px solid var(--color-success-border)', color: 'var(--color-success-ink)' }}>
                      <Icon name="sparkles" style={{ fontSize: 11 }} />{L('AI PICK', 'AI เลือก')}
                    </span>
                  )}
                </button>
              ))}
            </div>
            {showOverride && (
              <div style={{ background: 'var(--color-warning-bg)', border: '1px solid var(--color-warning)', borderRadius: 'var(--radius-md)', padding: 18 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 700, color: 'var(--color-fg-1)', marginBottom: 8 }}>
                  <Icon name="alert-triangle" style={{ color: 'var(--color-warning)' }} />{L('Override Justification', 'เหตุผลการแทนที่')}
                </div>
                <div style={{ fontSize: 12, color: 'var(--color-fg-2)', marginBottom: 10 }}>{L('You are selecting a bid other than the AI recommendation. Minimum 50 characters. This is logged and requires an additional DOA approval.', 'คุณกำลังเลือกข้อเสนอที่ไม่ใช่คำแนะนำของ AI ต้องมีอย่างน้อย 50 อักขระ การดำเนินการนี้จะถูกบันทึกและต้องได้รับการอนุมัติ DOA เพิ่มเติม')}</div>
                <textarea
                  value={state.overrideText}
                  onInput={(e) => set({ overrideText: (e.target as HTMLTextAreaElement).value })}
                  placeholder={L('Explain the business rationale for this override…', 'อธิบายเหตุผลทางธุรกิจสำหรับการแทนที่นี้…')}
                  style={{ width: '100%', minHeight: 90, padding: 11, border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', resize: 'vertical', background: 'var(--color-white)' }}
                />
                <div style={{ fontSize: 11, color: overrideCountColor, marginTop: 6, fontFamily: 'var(--font-mono)' }}>{overrideCount} {L('/ 50 characters minimum', '/ ต้องมีอย่างน้อย 50 อักขระ')}</div>
              </div>
            )}
            <button onClick={confirmAward} style={{ alignSelf: 'flex-start', padding: '12px 22px', background: 'var(--color-primary)', color: '#fff', borderRadius: 'var(--radius-md)', fontWeight: 600, fontSize: 15, opacity: confirmOpacity }}>{confirmLabel}</button>
          </div>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('RFQ Summary', 'สรุป RFQ')}</div>
            {rfqSummary.map((s, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '9px 0', borderBottom: '1px solid var(--color-border)' }}>
                <span style={{ fontSize: 12, color: 'var(--color-fg-3)' }}>{s.k}</span>
                <span style={{ fontSize: 13, fontWeight: 600, fontFamily: s.font, textAlign: 'right' }}>{s.v}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
